export const routes = {
  root: '/',
  embed: '/embed',
  // not utilized
  partnerWithoutCompany: '/partner',
  // home
  home: '/partner/:partner',
  // orderFinished
  orderFinished: '/pedido-finalizado',
  // categories
  categories: '/partner/:partner/:categoryId',
  service: '/partner/:partner/:categoryId',
  // old page tenant guarida
  tenantWithP: '/p/inquilino/:guarida',
  tenant: '/inquilino/:guarida',

  // old page parner guarida
  partnerWithP: '/p/parceiro/:guarida',
  partner: '/parceiro/:guarida',
};
